import { AUTH_URL } from "../constants";
import { AUTH_KEY } from "../context/authContext";
import { APIRequest, HTTPClient, RequestType } from "../services/http_client"
import LocalStorageService from "../services/localstorage.service";
import { AdCampaignType } from "../types/ads.campaign";

const client = new HTTPClient()

export interface ResponseType {
    adsCampaign?: {
        data: Array<AdCampaignType>;
    };
    total?: number;
    error?: string;
}

interface CRUDResponse {
    success: boolean;
    error: any;
}

class AdCampaignModel {
    static async find(adCampaignId: number){
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            RequestType.GET,
           `${AUTH_URL}/ads-campaign/${adCampaignId}`,
            undefined,
            auth.accessToken,
        );

        const response = await client.get(request);

        if (!response.success) {
            return {
                error: response.errorMessage,
            }
        }
  
        return response.result as unknown as ResponseType
    }

    static async saveAd(data: AdCampaignType){
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            data.id ? RequestType.PUT : RequestType.POST,
            data.id ? `${AUTH_URL}/ads-campaign/${data.id}` : `${AUTH_URL}/ads-campaign`,
            JSON.stringify(data),
            auth.accessToken,
        );

        const response =  data.id ? await client.put(request) : await client.post(request);

        if (!response.success) {
            return {
                error: response.errorMessage,
            }
        }
  
        return response.result as unknown as CRUDResponse
    }
}

export default AdCampaignModel